import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@chakra-ui/react";
import ResponsiveModal from "../common/ResponsiveModal";
const GetReservationDrawer = ({ isOpen, onOpen, onClose, drawerBody, header, pubColors }) => {
    var _a, _b;
    const bg = (_a = pubColors === null || pubColors === void 0 ? void 0 : pubColors.bg) !== null && _a !== void 0 ? _a : "#1E1E1E";
    const color = (_b = pubColors === null || pubColors === void 0 ? void 0 : pubColors.text) !== null && _b !== void 0 ? _b : "white";
    return (_jsx(ResponsiveModal, { isOpen: isOpen, onOpen: onOpen, onClose: onClose, header: header || "What's Your Plan?", bg: bg, color: color, children: _jsx(Flex, { w: "100%", flexDirection: "column", p: 4, pb: 8, children: drawerBody }) }));
};
export default GetReservationDrawer;
